import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';

const NcDmvHandicapDetails = ({ selectedHandicapPlacard, }) => {
  const formatMoney = (money) => {
    if (typeof money === 'string') return parseFloat(money).toFixed(2);
    return `${parseFloat(money.amount).toFixed(2)} ${money.currencyCode}`;
  };

  const formatDateTime = (dateString) => {
    if (dateString === undefined || dateString === null) return '';
    return `${new Date(dateString)}`;
  };

  return (
    <>
      <FieldSet title="Handicap Placard">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedHandicapPlacard.id,
          'Customer ID': selectedHandicapPlacard.customerId,
          'DL No.': selectedHandicapPlacard.externalAccountId,
          'Placard No.': selectedHandicapPlacard.externalBillId,
          'Original Bill Balance': formatMoney(selectedHandicapPlacard.originalBillBalance),
          'Client Reconciled Timestamp': selectedHandicapPlacard.clientReconciledTimestamp,
        })}
        />
      </FieldSet>

      <FieldSet title="Transaction">
        <VerticalLabelList items={VerticalLabelList.toList({
          Id: selectedHandicapPlacard.id,
          'Payment Transaction ID': selectedHandicapPlacard.paymentTransactionId,
          'Payment Transaction Line Item ID': selectedHandicapPlacard.paymentTransactionLineItemId,
          'Payment Amount': formatMoney(selectedHandicapPlacard.paymentAmount),
          'Payment Date': formatDateTime(selectedHandicapPlacard.paymentDate),
        })}
        />
      </FieldSet>
    </>
  );
};

export default NcDmvHandicapDetails;

NcDmvHandicapDetails.propTypes = {
  selectedHandicapPlacard: PropTypes.instanceOf(Object).isRequired,
};
